



























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { getYansetezheng } from "@/request/idr";
@Component({})
export default class IdrTongueBiaozhuYanse extends Vue {
  @Prop()
  private tongueId: any;
  private loaded: boolean = false;
  private filters: any = {
    类别: "舌色",
    部位: "全舌",
    色彩: "LAB"
  };
  private tubiao: any = {
    title: {
      textStyle: {
        color: "#333333",
        fontSize: 14,
        fontWeight: "normal"
      }
    },
    legend: {
      orient: "vertical",
      left: "0%",
      top: "10%",
      itemGap: 80
    },
    grid: [
      {
        top: "10%",
        height: "20%"
      },
      {
        top: "40%",
        height: "20%"
      },
      {
        top: "66%",
        height: "20%"
      }
    ],
    tooltip: {},
    xAxis: [
      {
        type: "category",
        gridIndex: 0
      },
      {
        type: "category",
        gridIndex: 1
      },
      {
        type: "category",
        gridIndex: 2
      }
    ],
    yAxis: [
      { gridIndex: 0, show: false },
      { gridIndex: 1, show: false },
      { gridIndex: 2, show: false }
    ],
    series: [
      {
        type: "bar",
        xAxisIndex: 0,
        yAxisIndex: 0
      },
      {
        type: "bar",
        xAxisIndex: 1,
        yAxisIndex: 1
      },
      {
        type: "bar",
        xAxisIndex: 2,
        yAxisIndex: 2
      }
    ]
  };
  private message: any = {};
  private th: any[] = [];
  private tr: any[] = [];
  /**
   * @description 获得颜色特征
   */
  private fetchYanse() {
    const params: any = {
      params: {
        tongue_id: this.tongueId,
        类别: this.filters["类别"],
        部位: this.filters["部位"],
        色彩: this.filters["色彩"]
      }
    };
    getYansetezheng(this, params).then((data: any) => {
      this.message = data;
      this.createTubiao();
      this.th = this.message["详细参数列表"].splice(0, 1)[0];
      this.tr = this.message["详细参数列表"];
    });
  }
  /**
   * @description 创建图表
   */
  private createTubiao() {
    this.tubiao.title.text = this.message["直方图名称"];
    if (this.filters["色彩"] === "LAB") {
      this.tubiao.series[0].name = "L";
      this.tubiao.series[0].data = this.message["直方图"]["L"];
      this.tubiao.series[1].name = "A";
      this.tubiao.series[1].data = this.message["直方图"]["a"];
      this.tubiao.series[2].name = "B";
      this.tubiao.series[2].data = this.message["直方图"]["b"];
    } else if (this.filters["色彩"] === "RGB") {
      this.tubiao.series[0].name = "R";
      this.tubiao.series[0].data = this.message["直方图"]["R"];
      this.tubiao.series[1].name = "G";
      this.tubiao.series[1].data = this.message["直方图"]["G"];
      this.tubiao.series[2].name = "B";
      this.tubiao.series[2].data = this.message["直方图"]["B"];
    } else if (this.filters["色彩"] === "HSV") {
      this.tubiao.series[0].name = "H";
      this.tubiao.series[0].data = this.message["直方图"]["H"];
      this.tubiao.series[1].name = "S";
      this.tubiao.series[1].data = this.message["直方图"]["S"];
      this.tubiao.series[2].name = "V";
      this.tubiao.series[2].data = this.message["直方图"]["V"];
    }
    this.loaded = true;
  }
  /**
   * @description 改变类别
   */
  private changeLeilie(leibie) {
    this.filters["类别"] = leibie;
    this.loaded = false;
    this.fetchYanse();
  }
  /**
   * @description 改变位置
   */
  private changeWeizhi(weizhi) {
    this.filters["部位"] = weizhi;
    this.fetchYanse();
  }
  /**
   * @description 改变色彩
   */
  private changeSecai(secai) {
    this.loaded = false;
    this.filters["色彩"] = secai;
    this.fetchYanse();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.tongueId) {
      this.fetchYanse();
    }
  }
}
